// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuDetails-sideMenuItem-yAh2Y {
    padding: 12px 16px;
    border-radius: var(--radius-1);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    margin-bottom: 4px;
    gap: 8px;
    color: var(--sideMenu-primary-foreground);
    text-decoration: none;
    text-align: start;
}

.SideMenuDetails-sideMenuItem-yAh2Y:hover,
.SideMenuDetails-sideMenuItem-yAh2Y:focus,
.SideMenuDetails-sideMenuItemActive-Vquzi,
.SideMenuDetails-sideMenuItemActive-Vquzi:hover,
.SideMenuDetails-sideMenuItemActive-Vquzi:focus {
    background: var(--sideMenu-hover);
    color: var(--sideMenu-primary-foreground);
    text-decoration: none;
}

.SideMenuDetails-sideMenuItem-yAh2Y:hover .SideMenuDetails-sideMenuItemIconContainer-M381F,
.SideMenuDetails-sideMenuItem-yAh2Y:focus .SideMenuDetails-sideMenuItemIconContainer-M381F,
.SideMenuDetails-sideMenuItemActive-Vquzi .SideMenuDetails-sideMenuItemIconContainer-M381F,
.SideMenuDetails-sideMenuItemActive-Vquzi:hover .SideMenuDetails-sideMenuItemIconContainer-M381F,
.SideMenuDetails-sideMenuItemActive-Vquzi:focus .SideMenuDetails-sideMenuItemIconContainer-M381F {
    color: var(--sideMenu-active-foreground);
}

.SideMenuDetails-sideMenuItemIconContainer-M381F {
    -ms-flex-negative: 0;
        flex-shrink: 0;
    position: relative;
    top: 2px;
    width: 20px;
    height: 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}

.SideMenuDetails-sideMenuItemIconContainer-M381F svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
    -o-object-position: center;
       object-position: center;
}

.SideMenuDetails-sideMenuItemTextContainer-fSkKk {
    -webkit-box-flex: 1;
        -ms-flex-positive: 1;
            flex-grow: 1;
    white-space: pre-line;
    word-break: break-word;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/SideBar/SideMenuDetails.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,yCAAyC;IACzC,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;;;;;IAKI,iCAAiC;IACjC,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;;;;;IAKI,wCAAwC;AAC5C;;AAEA;IACI,oBAAc;QAAd,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,0BAAuB;OAAvB,uBAAuB;AAC3B;;AAEA;IACI,mBAAY;QAAZ,oBAAY;YAAZ,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".sideMenuItem {\n    padding: 12px 16px;\n    border-radius: var(--radius-1);\n    display: flex;\n    align-items: flex-start;\n    margin-bottom: 4px;\n    gap: 8px;\n    color: var(--sideMenu-primary-foreground);\n    text-decoration: none;\n    text-align: start;\n}\n\n.sideMenuItem:hover,\n.sideMenuItem:focus,\n.sideMenuItemActive,\n.sideMenuItemActive:hover,\n.sideMenuItemActive:focus {\n    background: var(--sideMenu-hover);\n    color: var(--sideMenu-primary-foreground);\n    text-decoration: none;\n}\n\n.sideMenuItem:hover .sideMenuItemIconContainer,\n.sideMenuItem:focus .sideMenuItemIconContainer,\n.sideMenuItemActive .sideMenuItemIconContainer,\n.sideMenuItemActive:hover .sideMenuItemIconContainer,\n.sideMenuItemActive:focus .sideMenuItemIconContainer {\n    color: var(--sideMenu-active-foreground);\n}\n\n.sideMenuItemIconContainer {\n    flex-shrink: 0;\n    position: relative;\n    top: 2px;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.sideMenuItemIconContainer svg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    object-position: center;\n}\n\n.sideMenuItemTextContainer {\n    flex-grow: 1;\n    white-space: pre-line;\n    word-break: break-word;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sideMenuItem": `SideMenuDetails-sideMenuItem-yAh2Y`,
	"sideMenuItemActive": `SideMenuDetails-sideMenuItemActive-Vquzi`,
	"sideMenuItemIconContainer": `SideMenuDetails-sideMenuItemIconContainer-M381F`,
	"sideMenuItemTextContainer": `SideMenuDetails-sideMenuItemTextContainer-fSkKk`
};
module.exports = ___CSS_LOADER_EXPORT___;
